export const items = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",

  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",

  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",

  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Bootstrap",
  "Sass",
];
export const backendItems = [
  "Node.js",
  "Express.js",
  "MongoDB",
  "MySQL",
  "PHP",
  "Databases",
  "Rest APIs",
  "Authentication",
  "Scalability",
  "Security",
  "Node.js",
  "Express.js",
  "MongoDB",
  "MySQL",
  "PHP",
  "Databases",
  "Rest APIs",
  "Authentication",
  "Scalability",
  "Security",
  "Node.js",
  "Express.js",
  "MongoDB",
  "MySQL",
  "PHP",
  "Databases",
  "Rest APIs",
  "Authentication",
  "Security",
  "Scalability",
];
export const softSkills = [
  "Communication",
  "Teamwork",
  "Problem Solving",
  "Adaptability",
  "Time Management",
  "Leadership",
  "Critical Thinking",
  "Creativity",
  "Attention to Detail",
  "Decision Making",
  "Empathy",
  "Presentation",
  "Negotiation",
  "Organizational",
  "Communication",
  "Teamwork",
  "Problem Solving",
  "Adaptability",
  "Time Management",
  "Leadership",
  "Critical Thinking",
  "Creativity",
  "Attention to Detail",
  "Decision Making",
  "Empathy",
  "Presentation",
  "Negotiation",
  "Organizational",
  "Networking",
  "Stress Management",
  "Customer Service",
  "Project Management",
];
